"use client";

import { ReactNode } from "react";

import {
  ConfigSidebarCollapseButton,
  ConfigResetButton,
  ConfigApplyButton,
} from "./ConfigSidebarComponents";
import { MobileOverlay } from "../../../components/Overlay/MobileOverlay";
import { cn } from "../../../utils/style";

interface ConfigSidebarLayoutProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  isMobile: boolean;
  isOverflowing: boolean;
  contentRef: React.RefObject<HTMLDivElement>;
  onReset: () => void;
  onApply: () => void;
  disabled: boolean;
  children: ReactNode;
}

export function ConfigSidebarLayout({
  isOpen,
  onClose,
  className,
  isMobile,
  isOverflowing,
  contentRef,
  onReset,
  onApply,
  disabled,
  children,
}: ConfigSidebarLayoutProps) {
  return (
    <div className={cn("absolute inset-0", className)}>
      {/* 모바일 환경에서 패널 바깥 오버레이 렌더링 */}
      {isMobile && isOpen && (
        <MobileOverlay onClose={onClose} className="mobile:z-20" />
      )}
      <div
        className={cn(
          "absolute bottom-0 right-0 top-0",
          "mobile:z-50 mobile:w-full mobile:max-w-[calc(theme(width.config-sidebar))] mobile:shadow",
          "desktop:w-config-sidebar",
          "flex flex-col border-l border-t bg-subtle",
          "transition-all duration-300 ease-in-out",
          isOpen ? "translate-x-0" : "translate-x-full",
        )}
      >
        {/* 상단 */}
        <section className="flex-shrink-0 px-4">
          <div className="my-2.5 flex items-center justify-between">
            <div className="large text-surface-foreground">Configuration</div>
            <ConfigSidebarCollapseButton onClose={onClose} />
          </div>
        </section>

        {/* 옵션 리스트 */}
        <section
          ref={contentRef}
          className="flex-1 space-y-4 overflow-y-auto p-4 pt-0"
        >
          {children}
        </section>

        {/* 하단 */}
        <section
          className={cn(
            "flex h-footer flex-shrink-0 items-center p-4 mobile:h-mobile-footer",
            "transition-all duration-200 ease-in-out",
            isOverflowing ? "border-t" : "border-t-transparent",
          )}
        >
          <div className="flex w-full items-center justify-between">
            <ConfigResetButton onReset={onReset} disabled={disabled} />
            <ConfigApplyButton onApply={onApply} disabled={disabled} />
          </div>
        </section>
      </div>
    </div>
  );
}
